// Copyright (c) 2022 by Move Closer

import { AsyncComponent } from 'vue'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum BrandTeaserModuleVersion {
  Default = 'default',
  Novelties = 'novelties',
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const brandTeaserModuleVersionComponentRegistry: Record<string, AsyncComponent> = {
  [BrandTeaserModuleVersion.Default]: () => import(
    /* webpackChunkName: "modules/BrandTeaserDefault" */
    './versions/Default/Default.vue'
  ),
  [BrandTeaserModuleVersion.Novelties]: () => import(
    // webpackChunkName: "modules/BrandTeaserNovelties"
    './versions/Novelties/Novelties.vue'
  )
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const brandTeaserDefaultCarouselConfig = {
  autoplay: false,
  centralize: false,
  delay: 3000,
  hasPagination: true,
  hasButtons: true,
  initialSlide: 0,
  inLoop: false,
  pauseOnHover: true,
  responsive: {
    mobile: {
      perPage: 2.5,
      hasButtons: false,
      hasPagination: false
    },
    desktop: { perPage: 6 }
  }
}

export const brandTeaserNoveltiesCarouselConfig = {
  autoplay: false,
  centralize: false,
  delay: 3000,
  hasPagination: true,
  hasButtons: true,
  initialSlide: 0,
  inLoop: false,
  pauseOnHover: true,
  responsive: {
    mobile: {
      perPage: 3.25,
      hasButtons: false,
      hasPagination: false
    },
    desktop: { perPage: 5 }
  }
}
